export function extractTextFromLexical(lexicalJson: unknown): string {
  if (!lexicalJson || typeof lexicalJson !== 'object') {
    return ''
  }

  const json = lexicalJson as Record<string, unknown>
  const root = json.root as Record<string, unknown> | undefined

  if (!root?.children || !Array.isArray(root.children)) {
    return ''
  }

  return extractTextFromNodes(root.children).trim()
}

function extractTextFromNodes(nodes: unknown[]): string {
  const textParts: string[] = []

  for (const node of nodes) {
    if (!node || typeof node !== 'object') continue

    const nodeObj = node as Record<string, unknown>

    // Text node - extract the text content
    if (nodeObj.type === 'text' && typeof nodeObj.text === 'string') {
      textParts.push(nodeObj.text)
    }

    // Linebreak node - add newline
    if (nodeObj.type === 'linebreak') {
      textParts.push('\n')
    }

    // Paragraph/heading - add content then newline
    if (['paragraph', 'heading'].includes(nodeObj.type as string)) {
      if (Array.isArray(nodeObj.children)) {
        textParts.push(extractTextFromNodes(nodeObj.children))
      }
      textParts.push('\n')
    }

    // List item - add bullet then content
    if (nodeObj.type === 'listitem') {
      textParts.push('- ')
      if (Array.isArray(nodeObj.children)) {
        textParts.push(extractTextFromNodes(nodeObj.children))
      }
      textParts.push('\n')
    }

    // Other nodes with children - recurse
    if (
      Array.isArray(nodeObj.children) &&
      !['paragraph', 'heading', 'listitem'].includes(nodeObj.type as string)
    ) {
      textParts.push(extractTextFromNodes(nodeObj.children))
    }
  }

  return textParts.join('')
}

export function textToLexicalJson(text: string) {
  const paragraphs = text.split(/\n\n+/).filter((p) => p.trim())

  if (paragraphs.length === 0) {
    paragraphs.push('')
  }

  return {
    root: {
      type: 'root',
      format: '' as const,
      indent: 0,
      version: 1,
      children: paragraphs.map((paragraphText) => ({
        type: 'paragraph',
        format: '' as const,
        indent: 0,
        version: 1,
        children: [
          {
            mode: 'normal',
            text: paragraphText.trim(),
            type: 'text',
            style: '',
            detail: 0,
            format: 0,
            version: 1,
          },
        ],
        direction: null,
        textStyle: '',
        textFormat: 0,
      })),
      direction: null,
    },
  }
}
